import { ImageFileUrl } from "../model/media"
import { api } from "./api";


export const putImage = async (accessToken: string, image: File): Promise<ImageFileUrl> => {
    const form = new FormData();
    form.set('image', image)

    const response = await api.put<ImageFileUrl>(`/images`, form, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "multipart/form-data",
        },
    });

    return response.data as ImageFileUrl;
};